import ReactModify from './react-modify.vue';

export default ReactModify;